/**
 * 日期工具函数
 */

const pad = (n, len = 2) => String(n).padStart(len, '0')
/**
 * 格式化日期
 * @param {number|Date} timestamp - 时间戳（毫秒）或 Date 对象
 * @param {string} format - 格式字符串（例如：'yyyy-MM-dd hh:mm:ss'）
 * @returns {string} 格式化后的日期字符串
 */
export function dateFormater(timestamp, format = 'yyyy-MM-dd hh:mm:ss') {
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)

  const map = {
    yyyy: String(date.getFullYear()),
    MM: pad(date.getMonth() + 1),
    dd: pad(date.getDate()),
    HH: pad(date.getHours()),
    hh: pad(date.getHours() % 12 || 12),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
    SSS: pad(date.getMilliseconds(), 3),
  }

  return format.replace(
    /yyyy|MM|dd|HH|hh|mm|ss|SSS/g,
    (key) => map[key]
  )
}

 /**
* 判断两个时间戳是否是同一天
*/
export function isSameDay(timestamp1, timestamp2) {
 const date2 = new Date(timestamp2)
 const date2StartTimestamp = date2.setHours(0, 0, 0, 0)
 const date2EndTimestamp = date2.setHours(23, 59, 59, 999)
 return timestamp1 >= date2StartTimestamp && timestamp1 <= date2EndTimestamp
}

/**
 * 判断时间戳是否为今天
 * @param {number} timestamp - 时间戳（毫秒）
 * @returns {boolean}
 */
export function isToday(timestamp) {
  return isSameDay(timestamp, Date.now())
}


// 计算到今天的剩余毫秒数
export function getRemainMsToday() {
  const now = new Date()
  const tomorrow = new Date(now)
  tomorrow.setHours(24, 0, 0, 0) // 明天 00:00:00
  return tomorrow.getTime() - now.getTime()
}

// 计算到今天的剩余秒数
export function getRemainSecondsToday() {
  return Math.ceil(getRemainMsToday() / 1000)
}

/**
 * 格式化时长，最少显示分钟和秒
 * @param {number} duration - 时长（秒）
 * @returns {Object} 包含格式化字符串和各时间单位的对象
 * @property {string} formatStr - 格式化后的时长字符串
 * @property {number} days - 天数
 * @property {number} hours - 小时数
 * @property {number} minutes - 分钟数
 * @property {number} seconds - 秒数
 */
export function formattedDuration(duration) {
  const days = Math.floor(duration / 86400)
  const hours = Math.floor((duration % 86400) / 3600)
  const minutes = Math.floor((duration % 3600) / 60)
  const seconds = duration % 60
  const result = [];
  if (days > 0) {
    result.push(pad(days))
  }
  if (hours > 0) {
    result.push(pad(hours))
  }
  result.push(pad(minutes))
  result.push(pad(seconds))

  return {
    formatStr: result.join(':'),
    days,
    hours,
    minutes,
    seconds
  }
}
